import firebase from '../../firebase';

export default async function getServiceLevels(groupId) {
    return firebase.functions().httpsCallable('getServiceLevels')({
        groupId,
    });
}
